export default __webpack_public_path__ + "static/media/8.891bb5a1.png";